import Backbone from 'backbone'
import template from './files.hbs'
import _ from 'lodash'
import fileInfo from 'scoreboard/components/files/file-info'
import {download} from './file'
import CovertButtonTooltips from 'scoreboard/components/covert-button-tooltips'
import scoreboardUrl from 'scoreboard/components/scoreboard-url'
import globals from 'scoreboard/components/globals'

var FilesView = Backbone.View.extend({

	className: 'panel panel-with-table',

	events: {
		'click .download': 'download'
	},

	/**
	 * Options should look like this:
	 *
	 * <pre>
	 * var options = {
	 * 	  data : {
	 *      'id': 1,
	 * 		'label' : 'sub-folder',
	 * 		'type' : 'folder',
	 * 		'children' : [ {
	 * 			'id' : 1,
	 * 			'label' : 'Metric Update Form for use with Octopus ETL',
	 * 			'type' : 'document',
	 * 			'revisions' : [ {
	 * 				'id' : 13,
	 * 				'label' : 'PBLMetricUpdateForm.xls',
	 * 				'lastModified' : '2005-01-30T15:40Z'
	 * 			} ]
	 * 		} ]
	 * 	  }
	 * }
	 * </pre>
	 */
	initialize: function(options) {
		this.data = options && options.data
		this.documents = _.keyBy(this.data && this.data.children, 'id')
	},

	render: function() {
		var context = _.cloneDeep(this.data)
		context.children = _.transform(context.children, function(result, child) {
			// add extension and type to each child
			if (child.revisions && child.revisions[0]) {
				child.lastModified = child.revisions[0].lastModified
				var filename = child.revisions[0].label
				child.extension = fileInfo.extension(filename)
				var type = fileInfo.type(filename)
				child.type = type ? 'documents.fileType.' + type : null
				child.icon = fileInfo.icon(filename)
				if (child.icon == 'docs-image') {
					child.imageUrl = scoreboardUrl(`api/images/${child.revisions[0].id}/thumbnail?database=${globals.databaseId}`)
				}
				if (child.icon == 'docs-csv') {
					child.icon = 'docs-spreadsheet'
				}
			} else if (child.type == 'folder') {
				child.type = 'bookmarks.folder'
				child.isFolder = true
			}
			result.push(child)
		}, [])
		this.$el.empty().append(template(context))

		this.covertButtonTooltips = new CovertButtonTooltips({ el: this.el })

		return this
	},

	// returns the documentId for the given event
	_documentId: function(e) {
		return this.$(e.target).closest('[data-document-id]').data('document-id')
	},

	download: function(e) {
		// Don't pass the click to the clickable tr for navigation
		e.stopPropagation()
		download(this._documentId(e))
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.covertButtonTooltips], 'remove')
	}

})

export default FilesView

FilesView.__filename__ = 'components/files/files.js'
